import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: calc(100% - 40px);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 20px;

  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    max-width: 522px;
    height: 100vh;
    max-height: 479px;
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 80%;

  form {
    width: 100%;
  }
`

export const ButtonContainer = styled.div`
  ${({ theme }) => css`
    margin-top: 28px;
    width: 100%;
    align-content: flex-end;
    text-align: -webkit-right;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .resend-btn {
      background: transparent;
      width: 34%;
      border: none;
      box-shadow: none;
      cursor: pointer;
      transition: ${theme.transition.default};

      &:hover {
        color: ${theme.colors.lightGray};
        filter: brightness(0.9);
      }
    }

    > button {
      display: flex;
      align-items: center;
      width: 60%;
      justify-content: center;
      position: relative;
      box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.15);
      border: none;
    }

    .icon-arrow-right {
      position: absolute;
      right: 26px;
    }

    ${media.lessThan('medium')`
      .icon-arrow-right{
        display: none;
      }
      button{
        width: 74%;
      }
    `}
  `}
`

export const Subtitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    font-family: ${theme.font.montserrat};
    font-weight: ${theme.font.semiBold};
    font-size: ${theme.font.sizes.xxsmall};
    text-align: center;
    margin-top: 25px;
  `}
`

export const Description = styled.h3`
  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    font-family: ${theme.font.montserrat};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.xxsmall};
    text-align: center;
    margin-top: 12px;
    margin-bottom: 28px;
  `}
`
